export const graph_data_xbo8 = {

      frequencyMin: 8,
      frequencyMax: 300,
      tempRanges: ["0..50ºC", "-10..60ºC", "-30..70ºC", "-40..85ºC", "-60..85ºC"], //update from tx product
      signalTypes: ["sWave3p3V", "sWave5V", "hcmos3p3V", "hcmos5V"], //update from tx product
      availableMultipliers: ["Fundamental"],
      data: {
        stability: {
          frequencyPoints: [8, 10, 20, 30, 50, 60, 100, 150],
          data: {
            "0..50ºC": {
              "Fundamental": [2.0, 2, 2.3, 2.7, 3.3, 3.7, 5, 10]
            },
            "-10..60ºC": {
              "Fundamental": [2, 2, 2.3, 2.7, 3.3, 3.7, 5, 10]
            },
            "-30..70ºC": {
              "Fundamental": [2, 2, 2.9, 3.8, 5.6, 6.4, 10, 20]
            },
            "-40..85ºC": {
              "Fundamental": [3, 3, 4.3, 5.7, 8.3, 9.7, 15, 30]
            },
            "-60..85ºC": {
              "Fundamental": [10, 10, 12.2, 14.4, 18.9, 21.1, 30, 60]
            }
          }
        },
        aging: {
          frequencyPoints: [8, 50, 150],
          data: {
            "0..50ºC": {
              "Fundamental": [0.1, 1.5, 3]
            },
            "-10..60ºC": {
              "Fundamental": [0.1, 1.5, 3]
            },
            "-30..70ºC": {
              "Fundamental": [0.1, 1.5, 3]
            },
            "-40..85ºC": {
              "Fundamental": [0.2, 1.5, 3]
            },
            "-60..85ºC": {
              "Fundamental": [0.2, 1.5, 3]
            }
          }
        },
        consumption: {
            frequencyPoints: [8, 50, 150],
            data: {
              "0..50ºC": {
                "sWave3p3V": {
                  "Fundamental": [73.1, 77.9, 90]
                },
                "sWave5V": {
                  "Fundamental": [106.9, 118, 145.7]
                },
                "hcmos3p3V": {
                  "Fundamental": [66.5, 70.4, 80.3]
                },
                "hcmos5V": {
                  "Fundamental": [91.9, 100.7, 123]
                }
              },
              "-10..60ºC": {
                "sWave3p3V": {
                  "Fundamental": [83.3, 88.2, 100.3]
                },
                "sWave5V": {
                  "Fundamental": [117.1, 128.2, 155.9]
                },
                "hcmos3p3V": {
                  "Fundamental": [76.7, 80.7, 90.6]
                },
                "hcmos5V": {
                  "Fundamental": [102.1, 110.9, 133.2]
                }
              },
              "-30..70ºC": {
                "sWave3p3V": {
                  "Fundamental": [98.6, 103.4, 115.5]
                },
                "sWave5V": {
                  "Fundamental": [132.2, 143.3, 171.1]
                },
                "hcmos3p3V": {
                  "Fundamental": [92, 95.9, 105.8]
                },
                "hcmos5V": {
                  "Fundamental": [117.2, 126.1, 148.3]
                }
              },
              "-40..85ºC": {
                "sWave3p3V": {
                  "Fundamental": [122.8, 127.6, 139.7]
                },
                "sWave5V": {
                  "Fundamental": [156.1, 167.2, 195]
                },
                "hcmos3p3V": {
                  "Fundamental": [116.2, 120.2, 130.1]
                },
                "hcmos5V": {
                  "Fundamental": [141.1, 150, 172.2]
                }
              },
              "-60..85ºC": {
                "sWave3p3V": {
                  "Fundamental": [122.8, 127.6, 139.7]
                },
                "sWave5V": {
                  "Fundamental": [156.1, 167.2, 195]
                },
                "hcmos3p3V": {
                  "Fundamental": [116.2, 120.2, 130.1]
                },
                "hcmos5V": {
                  "Fundamental": [141.1, 150, 172.2]
                }
            }
          }
        }
      }
}